module.exports = __webpack_public_path__ + "img/banner-loading-4.8047d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading-4.jpg
// module id = ZVic
// module chunks = 9